import React from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../updateAction';

import BackButton from '../components/BackButton';
import Button from '../components/Button';
import Input from '../components/Input';
import Select from '../components/Select';
import StackForm from '../components/StackForm';
import Title from '../components/Title';
import { click_next_step4 } from '../techspec';

import { departamentos, localidades } from '../data';

const Address = props => {
  const { register, errors, handleSubmit, watch } = useForm({
    mode: 'onBlur',
  });
  const { action, state } = useStateMachine(updateAction);

  const onSubmit = data => {
    click_next_step4();

    action(data);
    props.history.push('/5');
  };

  const selectedDepartment = watch('department') || state?.data?.department || '';

  const getLocalidades = department => {
    if (!department) return [];

    let localidadesOptions = [];

    localidades.filter(localidad => {
      if (localidad[1] === department) {
        localidadesOptions.push({ label: localidad[0], value: localidad[0] });
      }
    });

    return localidadesOptions;
  };

  const preventSpecialChars = event => {
    const regex = new RegExp('[A-Za-z0-9\\s ñ .]+$');
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  };

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>Para seguir, necesitamos los datos de tu domicilio actual.</Title>

        <Select
          id="department"
          name="department"
          label="Departamento"
          placeholder="Seleccioná tu departamento"
          options={departamentos}
          register={register({ required: 'Debe seleccionar un departamento.' })}
          error={errors.department}
          defaultValue={state?.data?.department || ''}
        />

        <Select
          id="localidad"
          name="localidad"
          label="Localidad"
          placeholder="Seleccioná tu localidad"
          disabled={!selectedDepartment}
          register={register({ required: 'Debe seleccionar una localidad.' })}
          options={getLocalidades(selectedDepartment)}
          error={errors.localidad}
          defaultValue={state?.data?.localidad || ''}
        />

        <Input
          id="address"
          name="address"
          label="Dirección"
          placeholder="Ingresá tu dirección"
          defaultValue={state?.data?.address}
          register={register({ required: 'Debe ingresar su dirección.' })}
          error={errors.address}
          onKeyPress={preventSpecialChars}
        />
      </div>

      <div className="form-actions">
        <Button block type="submit" id="next-button-step-4">
          Siguiente
        </Button>

        <BackButton />
      </div>
    </StackForm>
  );
};

export default withRouter(Address);
